import { render, staticRenderFns } from "./HomeMobile.vue?vue&type=template&id=f85d8d0a&scoped=true"
import script from "./HomeMobile.vue?vue&type=script&lang=js"
export * from "./HomeMobile.vue?vue&type=script&lang=js"
import style0 from "./HomeMobile.vue?vue&type=style&index=0&id=f85d8d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85d8d0a",
  null
  
)

export default component.exports